export default "__VITE_ASSET__H7jK5SNM__"